module.exports = __webpack_public_path__ + "static/media/piano_jeff.d55a4331.jpg";